module.exports={
	"Form": "CustomerViewManifest",
	"Scope": "Customer-View",
	"Descriptors":
	{
		"CustomerDetails.GUIDCustomer":
		{
			"Name": "GUID",
			"Hash": "Customer-GUIDCustomer",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "CustomerIdentity",
				"Group": "CustomerIdentity"
			}
		},
		"CustomerDetails.Name":
		{
			"Name": "Customer Name",
			"Hash": "Customer-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "CustomerIdentity",
				"Group": "CustomerIdentity"
			}
		},
		"CustomerDetails.Code":
		{
			"Name": "Customer Code",
			"Hash": "Customer-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.Timezone":
		{
			"Name": "Timezone",
			"Hash": "Customer-Timezone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.Enabled":
		{
			"Name": "Enabled",
			"Hash": "Customer-Enabled",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "CustomerSettings",
				"Group": "CustomerSettings"
			}
		},
		"CustomerDetails.CustomProperties":
		{
			"Name": "Custom Properties (JSON)",
			"Hash": "Customer-CustomProperties",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "CustomerCustomProperties",
				"Group": "CustomerCustomProperties"
			}
		},
		"CustomerDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "Customer-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "Customer-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "Customer-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		},
		"CustomerDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "Customer-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "CustomerAudit",
				"Group": "CustomerAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CustomerIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CustomerIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "CustomerSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "CustomerSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Custom Properties",
			"Hash": "CustomerCustomProperties",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Custom Properties",
					"Hash": "CustomerCustomProperties",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "CustomerAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "CustomerAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
